export default "__VITE_ASSET__BEN$JpRs__"